// Local (browser) storage for paint estimates.
// Lets users keep a snapshot of an estimate in their browser without any account,
// independent of the cloud (device DB) copy. Snapshots survive page reloads and
// can be downloaded as a portable JSON backup file.

const KEY = "pe_browser_estimates";

export const getBrowserEstimates = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

export const saveBrowserEstimate = ({ project, estimate }) => {
  const list = getBrowserEstimates();
  const snapshot = {
    projectId: project.id,
    name: project.name,
    clientName: project.client_name || "",
    totalCost: estimate?.client_total ?? null,
    savedAt: new Date().toISOString(),
    project,
    estimate,
  };
  // Replace any existing snapshot for the same project
  const next = [snapshot, ...list.filter((s) => s.projectId !== project.id)];
  localStorage.setItem(KEY, JSON.stringify(next));
  return snapshot;
};

export const removeBrowserEstimate = (projectId) => {
  const next = getBrowserEstimates().filter((s) => s.projectId !== projectId);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};

export const downloadBrowserEstimate = (snapshot) => {
  const blob = new Blob([JSON.stringify(snapshot, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${(snapshot.name || "estimate").replace(/\s+/g, "_")}_backup.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
